import { render } from "./AdminBanner.vue?vue&type=template&id=e556fd5a&scoped=true"
import script from "./AdminBanner.vue?vue&type=script&lang=js"
export * from "./AdminBanner.vue?vue&type=script&lang=js"

import "./AdminBanner.vue?vue&type=style&index=0&id=e556fd5a&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e556fd5a"]])

export default __exports__